export function checkStorageSupport() {
    if (window.sessionStorage) {
        return true;
    } else {
        return false;
    }
}

export function setStorage(key, value) {
    try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.log(e.message)
    }
}

export function getStorage(key) {
    const value = window.sessionStorage.getItem(key);
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}

export function clearStorage(key) {
    window.sessionStorage.removeItem(key);
}
